export default __webpack_public_path__ + "static/media/Chat-Numbers-System-17.b0d8f992.svg";